export default {
    title: 'Case Management',
    details: {
        title: 'Details',
    },
    fields: {
        started: 'Date created',
        status: 'Status',
        assign: 'Assigned to',
        result: 'Result',
        'case-id': 'Case ID',
        'date-created': 'Created at',
        tags: 'Tags',
        search: 'Search by case ID or company number',
        workflow: 'Workflow',
        source: 'Source',
        'company-number': 'Company Number',
    },
    'not-available': 'Not available',
    'clear-filters': 'Clear filters',
    'status-options': {
        all: 'All',
        created: 'Created',
        running: 'Running',
        completed: 'Completed',
        awaiting: 'Awaiting',
        failed: 'Failed',
        'timed-out': 'Timeout',
        terminated: 'Terminated',
        paused: 'Paused',
    },
    'party-type': {
        business: 'Business data',
    },
    semantics: {
        business: {
            name: 'Name',
            number: 'Company Registration Nº',
            address: 'Address',
            companyName: 'Name',
            companyNumber: 'Company Registration Nº',
            companyAddress: 'Address',
        },
    },
    'data-update-success': 'Data successfully updated!',
    comments: {
        title: 'Comments',
        button: 'Comment',
        'edit-button': 'Edit comment',
        'empty-list': 'The comment section is currently empty. You can add your own comment to the list.',
    },
    'case-list': {
        header: {
            id: 'Case ID',
            'first-name': 'First Name',
            'last-name': 'Last Name',
            'company-name': 'Company Name',
            'company-number': 'Company Number',
            tags: 'Tags',
            created: 'Created',
            result: 'Result',
            assignment: 'Assignment',
            'personal-number': 'Personal Number',
            email: 'Email',
            phone: 'Phone',
            'company-address': 'Company Address',
        },
    },
    'create-case': {
        trigger: 'New Case',
        title: 'Create Case',
        description: 'Fill in your details, upload your documents, create your case and instantly get a peek at your personalized workflow through a unique link.',
        submit: 'Create case',
        cancel: 'Cancel',
        created: 'Case has been created',
        label: {
            'select-workflow': 'Select Workflow',
            'first-name': 'First Name',
            'last-name': 'Last Name',
            'personal-number': 'National Identity Number',
            email: 'Email',
            phone: 'Phone no.',
            'company-name': 'Company Name',
            'company-number': 'Company Number',
            'company-address': 'Company Address',
            documents: 'Documents',
            other: 'Other',
        },
    },
    documents: {
        id: 'Id',
        name: 'Name',
        path: 'Path',
    },
    'edit-case': {
        title: 'Edit Case Details',
        description: 'Adjust Your Case Information',
        trigger: 'Edit Case',
        updated: 'Case Details have been updated',
    },
    'case-base-info': {
        document: {
            title: 'Document {no}',
        },
        label: {
            'first-name': 'First Name',
            'last-name': 'Last Name',
            'personal-number': 'National Identity Number',
            email: 'Email',
            phone: 'Phone no.',
            'country-code': 'Phone dial code',
            'company-name': 'Company Name',
            'company-number': 'Company Number',
            'company-address': 'Company Address',
            documents: 'Documents',
            other: 'Other',
        },
    },
    'tag-removed': 'Tag {tag} has been removed',
    'run-workflow': {
        trigger: 'Run Workflow',
        again: 'Run Workflow again',
        modal: {
            title: 'Run Workflow',
            description: {
                case: 'Select the workflow that you want to use for this case',
                onboarding: 'The workflow will be launched in a new tab and you will be able to check its results in the workflow executions tab',
                monitoring: 'The workflow will run in the background and you will be able to check its results in the workflow executions tab',
            },
            'title-with-name': 'Run workflow "{name}"',
            'running-title': 'Running Workflow...',
            'please-wait': 'Please wait',
        },
        success: {
            title: 'Success!',
            description: 'Everything went well and the case has been updated correctly.',
        },
        fail: {
            description: 'Workflow execution failed.',
        },
    },
    filters: {
        search: 'Search case',
        assignment: 'Assignment',
        created: 'Created at',
        tags: 'Tags',
        result: 'Result',
    },
}
